import { render, staticRenderFns } from "./pause-24.vue?vue&type=template&id=607bb8ad&scoped=true"
import script from "./pause-24.vue?vue&type=script&lang=js"
export * from "./pause-24.vue?vue&type=script&lang=js"
import style0 from "./pause-24.vue?vue&type=style&index=0&id=607bb8ad&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607bb8ad",
  null
  
)

export default component.exports